import "./Compliance.module.css";
import Header from "@/reusable_sections/Header";
import Compliance from "./sections/Compliance";
import Certifications from "./sections/Certifications";
import ComplianceFaq from "./sections/ComplianceFaq";
import Share from "./sections/Share";
import Footer from "@/reusable_sections/Footer";
export default function CompliancePage() {
  return <div>
      <Header />
      <Compliance />
      <Certifications />
      <ComplianceFaq />
      <Share />
      <Footer />
    </div>;
}